import { useLayoutEffect, useRef, useState } from 'react';

/** Design canvas size demos are authored for; scaled down on narrow/short viewports. */
export const DEMO_DESIGN_WIDTH = 240;
export const DEMO_DESIGN_HEIGHT = 360;

export default function DemoScaleWrapper({ children }) {
  const containerRef = useRef(null);
  const [scale, setScale] = useState(1);

  useLayoutEffect(() => {
    const el = containerRef.current;
    if (!el) return undefined;

    const update = () => {
      const { width, height } = el.getBoundingClientRect();
      if (width <= 0 || height <= 0) return;
      const next = Math.min(
        width / DEMO_DESIGN_WIDTH,
        height / DEMO_DESIGN_HEIGHT,
        1
      );
      setScale(next);
    };

    update();
    const observer = new ResizeObserver(update);
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <div ref={containerRef} className="flex h-full w-full items-center justify-center">
      <div
        className="shrink-0 overflow-hidden"
        style={{
          width: DEMO_DESIGN_WIDTH,
          height: DEMO_DESIGN_HEIGHT,
          transform: `scale(${scale})`,
          transformOrigin: 'center center',
        }}
      >
        {children}
      </div>
    </div>
  );
}
